
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ArabicLegalDialogsProps {
  termsOpen: boolean;
  setTermsOpen: (value: boolean) => void;
  privacyPolicyOpen: boolean;
  setPrivacyPolicyOpen: (value: boolean) => void;
  openFullTerms?: () => void;
  openFullPrivacy?: () => void;
}

export const ArabicLegalDialogs = ({
  termsOpen,
  setTermsOpen,
  privacyPolicyOpen,
  setPrivacyPolicyOpen,
  openFullTerms,
  openFullPrivacy
}: ArabicLegalDialogsProps) => {
  const navigate = useNavigate();

  const handleFullTermsClick = () => {
    setTermsOpen(false);
    if (openFullTerms) {
      openFullTerms();
    } else {
      // Navigate to Arabic terms page
      navigate("/ar/terms");
    }
  };

  const handleFullPrivacyClick = () => {
    setPrivacyPolicyOpen(false);
    if (openFullPrivacy) {
      openFullPrivacy();
    } else {
      // Navigate to Arabic privacy page
      navigate("/ar/privacy");
    }
  };

  return (
    <>
      <Dialog open={termsOpen} onOpenChange={setTermsOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>الشروط والأحكام</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="mb-4">تحكم هذه الشروط والأحكام استخدامك لخدمة Lainasampo.fi لمقارنة عروض القروض.</p>
              <p className="mb-4">باستخدام خدمتنا، فإنك تتفهم أننا سنشارك معلومات طلبك مع البنوك والمؤسسات المالية الشريكة لنا لغرض تقديم عروض القروض.</p>
              <p className="mb-4">يجب عليك تقديم معلومات دقيقة وصادقة في طلب القرض الخاص بك. قد يؤدي تقديم معلومات كاذبة إلى رفض طلبك وقد يعتبر احتيالًا.</p>
              <p className="mb-4">لا تضمن Lainasampo.fi أنك ستتلقى عروض قروض أو أنك ستتم الموافقة على أي قرض. يتم اتخاذ قرار الموافقة على القروض فقط من قبل المؤسسات المالية الشريكة لنا وفقًا لمعاييرهم.</p>
            </div>
          </DialogDescription>
          <div className="flex flex-col md:flex-row justify-between mt-4 gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleFullTermsClick}
              className="w-full md:w-auto"
            >
              قراءة الشروط والأحكام كاملة
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => setTermsOpen(false)}
              className="w-full md:w-auto"
            >
              إغلاق
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      
      <Dialog open={privacyPolicyOpen} onOpenChange={setPrivacyPolicyOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>سياسة الخصوصية</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="mb-4">تصف سياسة الخصوصية هذه كيفية جمع Lainasampo.fi واستخدام ومشاركة معلوماتك الشخصية عند استخدام خدمتنا.</p>
              <p className="mb-4">نجمع المعلومات الشخصية التي تقدمها في طلب القرض الخاص بك، بما في ذلك اسمك وتفاصيل الاتصال والمعلومات المالية وتفاصيل التوظيف.</p>
              <p className="mb-4">نحن نشارك معلوماتك مع البنوك والمؤسسات المالية الشريكة لنا لغرض إنشاء عروض قروض لك. قد نستخدم أيضًا معلوماتك لتحسين خدمتنا والتواصل معك بشأن طلبك.</p>
              <p className="mb-4">نحن نطبق تدابير أمنية مناسبة لحماية معلوماتك الشخصية ونحتفظ بها فقط طالما كان ذلك مطلوبًا للأغراض الموضحة في هذه السياسة.</p>
            </div>
          </DialogDescription>
          <div className="flex flex-col md:flex-row justify-between mt-4 gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleFullPrivacyClick}
              className="w-full md:w-auto"
            >
              قراءة سياسة الخصوصية كاملة
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => setPrivacyPolicyOpen(false)}
              className="w-full md:w-auto"
            >
              إغلاق
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
